module.exports = __webpack_public_path__ + "static/media/port.5da25056.jpeg";